import Datepicker from 'vuejs-datepicker';

export default {
  components: {
    Datepicker,
  },
};
